import dayjs from "dayjs";
import {
    getOrderOpenedCheckoutListByPoints,
    getPointInfoCollection,
    thunkCall,
} from "tm-shared/api";
import { backendDateFormat } from "tm-shared/constants";

export const getPointInfoCollectionUnplannedThunk = thunkCall(
    "getPointInfoCollectionUnplannedThunk",
    getPointInfoCollection,
);

export const getOrderOpenedYesterdayCheckoutListThunk = thunkCall(
    "getOrderOpenedYesterdayCheckoutListThunk",
    ({ routeId }: { routeId: string }) => {
        return getOrderOpenedCheckoutListByPoints({
            routeId,
            targetDate: dayjs()
                .subtract(1, "day")
                .format(backendDateFormat.date),
        });
    },
);
